export default "__VITE_ASSET__BcGnlsRN__"